var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 14V2H14V14H2ZM3 5.66667H13V3H3V5.66667ZM6.66667 9.33333H9.33333V6.66667H6.66667V9.33333ZM6.66667 13H9.33333V10.3333H6.66667V13ZM3 9.33333H5.66667V6.66667H3V9.33333ZM10.3333 9.33333H13V6.66667H10.3333V9.33333ZM3 13H5.66667V10.3333H3V13ZM10.3333 13H13V10.3333H10.3333V13Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/Table.c0c3b9b856d2878daf6d4f1058ef9d45.svg";
export { ForwardRef as ReactComponent };